import { multiReplace } from "@sparks-notation/util/string"

/**
 * 谱面文本字体的字族别名。
 *
 * 谱面里的中文/西文文本（歌词、标题、作者、章节序号…）历史上用三个专用 family
 * （CommonSerif / CommonLight / CommonBlack），对应 `core-resources/font` 下
 * 三个 2-8MB 的大文件。为把"打开乐谱"的首屏等待从分钟级压到秒级，这三个大字体
 * **不再作为独立文件加载**（见 FontLoaderProxy 的清单），而是把 family 名重定向到
 * 站点 UI 已经自托管好的子集字体上：
 *
 *   CommonSerif（宋体类）→ 'SBT Serif'，UI 宋体子集已随页面加载
 *   CommonLight（细黑类）→ 'SBT Sans'
 *   CommonBlack（黑体类）→ 'SBT Sans'
 *
 * 这些别名都写成**字体栈**而不是单名：SBT 子集只覆盖固定 UI 文案的字符，
 * 用户歌词是动态内容、必然有子集外的字 —— 栈后面的系统宋体/黑体逐字兜底，
 * 与 UI 层 tokens.ts 的字体栈同一策略。音符符号字体（SparksNMN-*、Roman）
 * 不在别名表里，仍从 core-resources 加载（合计 ~1MB）。
 *
 * ⚠️ 桌面版与网页版共用本文件；SBT 字体两端的 URL 不同但 family 名一致，
 *    别名对两端同样成立。
 */
const FAMILY_ALIASES: {[_: string]: string} = {
	'CommonSerif': "'SBT Serif', 'Songti SC', 'SimSun', serif",
	'CommonLight': "'SBT Sans', 'PingFang SC', 'Microsoft YaHei', sans-serif",
	'CommonBlack': "'SBT Sans', 'PingFang SC', 'Microsoft YaHei', sans-serif",
}

export class FontMetric {
	fontFamily: string
	fontWeight: number
	fontScale: number
	fontSize: number

	constructor(descriptor: string, fontSize: number) {
		const tokens = descriptor.split('/')
		const family = multiReplace(tokens[0], [['_', ' '], ['__', '_']])
		this.fontFamily = FAMILY_ALIASES[family] ?? family
		this.fontWeight = 400
		this.fontScale = 1
		if(tokens[1]) {
			let val = +tokens[1]
			if(val == val && 100 <= val && val <= 1000) {
				this.fontWeight = val
			}
		}
		if(tokens[2]) {
			let val = +tokens[2]
			if(val == val && 0 <= val && val < 128) {
				this.fontScale = val
			}
		}
		this.fontSize = fontSize
	}


}
